import styled from 'styled-components';
import {
  BaseColumnWrap,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const UGCCardContainer = styled.div(
  props => `
  margin-bottom: 10px;
`,
);

export const UGCPersuasionHeadingContainer = styled.div(
  props => `
  border-bottom: ${props.theme.misc.border.base} solid #e4e4e4;
  padding:${props.theme.spacing.custom(14)} ${props.theme.spacing.base};
`,
);

export const Text_Heading_UGCPersuasion = styled.h3(
  props => `
  display: inline-flex;
  font-size:${props.theme.font.custom(14)};
  font-weight: 600;
`,
);

export const ChipsContainer = styled(BaseColumnWrap)`
  height: 10.6rem;
`;

export const ChipsList = styled.ul(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: row;
  align-items: center;
  padding:${props.theme.spacing.base};
  justify-content:space-between;
  li {
    display: flex;
    flex-wrap:wrap;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    padding:${props.theme.spacing.custom(6)};
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-bottom:${props.theme.spacing.base};
    background-color:${props.theme.colors.goBrandBlue.light};
    text-align:center;
  }
`,
);

export const AmenitiesList = styled.ul(
  props => `
  display: flex;
  flex-direction: column;
  padding:${props.theme.spacing.base};

  li {
    display: flex;
    align-items: center;
    padding:${props.theme.spacing.small};
    margin-bottom:${props.theme.spacing.small};
  }
`,
);

export const ChipText = styled.span(
  props => `
  width:11.7rem;
  font-size:${props.theme.font.custom(14)};
  color:${props.theme.colors.downriver.dark};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`,
);

export const AmenitiesText = styled.span(
  props => `
  display:flex;
  font-size:${props.theme.font.custom(14)};
  color:${props.theme.colors.downriver.base};
  margin-left:${props.theme.spacing.base};
`,
);

export const CheckInCheckOutContainer = styled.div(
  props => `
  display:flex;
  border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  padding:${props.theme.spacing.xlarge};
`,
);

export const CheckInCheckOutInner = styled.div(
  props => `
  margin-right:${props.theme.spacing.xxlarge};
`,
);

export const CheckInCheckOutLabel = styled.p(
  props => `
  color:${props.theme.colors.downriver.dark};
  margin-bottom:${props.theme.spacing.small};
`,
);

export const CheckInCheckOutTime = styled.span(
  props => `
  font-weight: 600;
  font-size: ${props.theme.font.large};
`,
);

export const ViewAllAmenities = styled(PrimaryLink)(
  props => `
  padding:0 ${props.theme.spacing.large};
  margin-bottom: 1rem;
`,
);
